<template>
  <div id="app">
    <desktop-inactive v-if="!isMobile && isLoaded && (quizStatus === 'inactive')" > </desktop-inactive>
    <mobile-inactive v-else-if="isLoaded && (quizStatus === 'inactive')"> </mobile-inactive>
    <desktop-quiz v-if="!isMobile && isLoaded && (quizStatus === 'active')"></desktop-quiz>
    <mobile-quiz v-else-if="isLoaded && (quizStatus === 'active')"></mobile-quiz>
    <desktop-completed v-else-if="!isMobile && isLoaded && (quizStatus === 'completed')"> </desktop-completed>
    <mobile-completed v-else-if="isLoaded && (quizStatus === 'completed')"> </mobile-completed>
    <desktop-game v-else-if="!isMobile && isLoaded && (quizStatus === 'yetToStart')" > </desktop-game>
    <mobile-game  v-else-if="isLoaded && (quizStatus === 'yetToStart')"> </mobile-game>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DesktopQuiz from './components/quizdesktop/index.vue';
import MobileQuiz from './components/quizmobile/index.vue';
import DesktopCompleted from './components/quizdesktop/quizcompleted'
import MobileCompleted from './components/quizmobile/quizcompleted'
import DesktopInactive from './components/quizdesktop/inactive'
import MobileInactive from './components/quizmobile/inactive'
import DesktopGame from './components/quizdesktop/yettostart'
import MobileGame from './components/quizmobile/yettostart'

export default {
  name: 'Quiz',
  components: {
    DesktopQuiz,
    MobileQuiz,
    DesktopCompleted,
    MobileCompleted,
    DesktopInactive,
    DesktopGame,
    MobileInactive,
    MobileGame

  },
   computed: {
    ...mapGetters(['isLoaded' , 'quizStatus']),
  },
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
  },
  mounted(){
      this.$store.dispatch('getEventId',{
        eventId: this.$route.params.quiz,
      });
  }
};
</script>
